import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import TelegramDrainWalletsList from "./TelegramDrainWalletsList";
import TelegramDrainWalletsFilter from "./TelegramDrainWalletsFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import TelegramAddDrainWalletDialog from "./TelegramAddDrainWalletDialog";
import DialogModal from "../../../elements/dialogModal/DialogModal";

const TelegramDrainWalletsContainer = () => {
  const { t } = useTranslation("telegramBotPage");
  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "currentTab": checkFilterItem(history, "currentTab", "drainWallets", false, true),
    "projectId": checkFilterItem(history, "projectId", null),
  });

  const [bots, setBots] = useState([]);
  const [botsLoading, setBotsLoading] = useState(false);
  const [wallets, setWallets] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [notification, setNotification] = useState({ visible: false, type: "", message: "" });

  const fetchBots = () => {
    if (botsLoading) return;
    setBotsLoading(true);
    axios.get("/api/telegram/bots", userAuthenticationConfig()).then(response => setBots(response.data || [])).catch(() => setBots([])).finally(() => setBotsLoading(false));
  };

  const fetchWallets = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);
    setWallets(null);
    axios.get("/api/telegram/drain-wallets" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === 200) setWallets(response.data["hydra:member"]);
    }).catch(error => {
      setNotification({
        visible: true,
        type: "error",
        message: error?.response?.data?.message || t("drainWallets.errors.load")
      });
      setWallets([]);
    });
  };

  useEffect(() => {
    fetchWallets();
  }, [filterData]);

  const handleDeleteWallet = () => {
    axios.delete(`/api/telegram/drain-wallets/${deleteId}`, userAuthenticationConfig())
      .then(response => {
        if (response.status === 204) {
          setOpenDelete(false);
          setNotification({ visible: true, type: "success", message: t("drainWallets.success.deleted") });
          fetchWallets();
        }
      })
      .catch(error => {
        setNotification({ visible: true, type: "error", message: error?.response?.data?.message || t("drainWallets.errors.delete") });
      });
  };

  return (
    <>
      <Notification notification={notification} setNotification={setNotification} />
      <div className="content-head" style={{ justifyContent: "space-between" }}>
        <TelegramDrainWalletsFilter
          filterData={filterData}
          setFilterData={setFilterData}
          bots={bots}
          botsLoading={botsLoading}
          onOpen={fetchBots}
          t={t}
        />
        <TelegramAddDrainWalletDialog
          setNotification={setNotification}
          onAdded={fetchWallets}
          t={t}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <TelegramDrainWalletsList
        wallets={wallets}
        onActivated={fetchWallets}
        onDelete={(id) => {
          setDeleteId(id);
          setOpenDelete(true);
        }}
        setNotification={setNotification}
        t={t}
      />
      <DialogModal
        open={openDelete}
        setOpen={setOpenDelete}
        title={t("drainWallets.dialog.deleteTitle")}
        content={t("drainWallets.dialog.deleteText")}
        cancelButton={t("drainWallets.dialog.cancel")}
        approveButton={t("drainWallets.dialog.delete")}
        onApprove={handleDeleteWallet}
      />
    </>
  );
};

export default TelegramDrainWalletsContainer;
